export function FilterGroup({ label, options, value, onChange }) {
  return (
    <div className="flex items-center gap-2">
      <span className="text-sm opacity-60">{label}</span>
      <div className="flex rounded-xl border border-theme-secondary bg-theme-secondary/40 p-1">
        {options.map((opt) => (
          <button
            key={opt.id}
            type="button"
            onClick={() => onChange(opt.id)}
            className={`px-3 py-1.5 rounded-lg text-sm transition-colors ${
              value === opt.id
                ? 'bg-theme-main text-theme-primary shadow-sm font-medium'
                : 'text-theme-text opacity-70 hover:opacity-100'
            }`}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export function FilterSelect({ label, value, onChange, options, allLabel = 'All' }) {
  return (
    <label className="text-sm flex items-center gap-2">
      <span className="opacity-60 whitespace-nowrap">{label}</span>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="rounded-xl border border-theme-secondary bg-theme-main px-3 py-1.5 text-sm min-w-[120px]"
      >
        <option value="">{allLabel}</option>
        {options.map((o) => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
    </label>
  );
}
